module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "frontMatterPage",
    attrs: {
      "id": "ack01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page13"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber1"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/thomasjefferson_con#ack_01"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Acknowledgments")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstLetters"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("M")])]), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("Y PRINCIPAL THANKS")]), _vm._v(" are due to the late William Appleton Coolidge of Topsfield, Massachusetts. A direct descendant of Ellen Wayles Coolidge, Thomas Jefferson’s granddaughter by Thomas Mann and Martha Jefferson Randolph, he endowed the Atlantic Crossing scholarship at Balliol College, Oxford, which first brought me to these United States in 1970 and which makes me, I suppose, an indirect beneficiary of the peculiar Monticello system.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In January and February of 2004, I was invited to give four lectures and two seminars on Thomas Jefferson at the James Madison College of Michigan State University. The LeFrak Forum and Symposium on Science, Reason, and Modern Democracy provided me with an environment that was at once welcoming and intimidating, and I want very warmly to thank its directors, Arthur Melzer, Jerry Weinberger, and Richard Zinman, for giving me the opportunity of testing my opinions and conclusions against those of superior mind and experience.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page14"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("It was a fair wind that brought me, some years ago, into contact with Professor Annette Gordon Reed of New York University. Her pursuit of truth in the study of Jefferson is a model of historical objectivity, forensic scruple, and moral sense.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To have decided to pass a certain time “immersed” either in Jefferson’s work or in works about Jefferson is as impossible to regret as it is near impossible to undertake. No single person can now claim to have the entire store of existing knowledge. Everybody concerned must, of course, dip their flags to Julian Boyd, editor of the still-expanding twenty-seven-volume edition of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Papers of Thomas Jefferson")]), _vm._v(" prepared for the press at Princeton University, and to Dumas Malone’s six-volume biography "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jefferson and His Time")]), _vm._v(". It is an honor, even when it is not a pleasure, to register disagreement with the second of these. The finest, and the best written, of the more condensed Jefferson biographies is Merrill Peterson’s, succeeded, as I am sure he would himself admit, by the work of R. B. Bernstein.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Gore Vidal’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Burr")]), _vm._v(" is the best fictional re-creation of the period and forms a keystone in the grand historical-novelistic architecture that is already Mr. Vidal’s memorial. Conor Cruise O’Brien’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Long Affair")]), _vm._v(" is the most eloquent of the anti-Jeffersonian nonfictions, followed by the work of Albert Jay Nock. John Chester Miller’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Wolf by the Ears")]), _vm._v(" was for me the most various and illuminating account of the slavery question. On the much-neglected subject of the Barbary war, I found myself gratefully dependent upon "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Jefferson’s War")]), _vm._v(", by Joseph Whelan, and upon "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("To the Shores of Tripoli")]), _vm._v(", by A. B. C. "), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Whipple, upon Evan Thomas’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("John Paul Jones")]), _vm._v(", and even more dependent on Linda Colley’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Captives")]), _vm._v(", which reminded me once again that much of the Jeffersonian story is to be found in books that are ostensibly concerned with other subjects. This would also be true of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Undaunted Courage")]), _vm._v(", Stephen Ambrose’s account of the Lewis and Clark expedition, of John Keane’s exceptional biography of Thomas Paine, of Ron Chernow’s exemplary life of Alexander Hamilton, of Gordon S. Wood’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Radicalism of the American Revolution")]), _vm._v(", Bernard Bailyn’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ideological Origins of the American Revolution")]), _vm._v(", and of Theodore Draper’s astonishingly original account of the American Revolution, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("A Struggle for Power")]), _vm._v(", which replaces that emphasis on radicalism in another way. Those who study Jefferson must also study Edmund Burke, an obvious admission which again puts me in the debt of Conor Cruise O’Brien for his book "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Great Melody")]), _vm._v(" and of David Bromwich for his meticulous editing of Burke’s writings "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On Empire, Liberty, and Reform")]), _vm._v(".")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Jefferson’s Children: The Story of One American Family")]), _vm._v(", by Shannon Lanier and Jane Feldman, is one of the most striking pieces of Americana ever published. It assembles all the living descendants of Thomas Jefferson and Sally Hemings, and prints their photographs as well as their narratives. The book carries an introduction by Lucian K. Truscott IV, an “authorized” direct descendant of Jefferson—his fifth great-grandson—whose decency and honesty helped bring about this reunion, and who thereby helped refute his ancestor’s sorry belief that such love, coexistence, and mutual esteem would never be possible. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mutato nomine, et de te fabula narratur.")])])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("To list more sources might be to run the risk of boasting rather than acknowledging. I have learned in the course of this undertaking that anyone who writes about America is writing about Thomas Jefferson in one way or another, and so—as with the magnificent Jefferson Room in the Library of Congress, where I have spent so many absorbing days in the last quarter-century—I am tempted to annex, with all their ambivalence, the incised lines that commemorate Sir Christopher Wren at St. Paul’s: Reader, if you seek his monument, look around you.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page17"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page18"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70d0e62c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/thomasjefferson_ack01.vue
// module id = 72
// module chunks = 0